import { render, staticRenderFns } from "./CreateCoachResumeAccolades.vue?vue&type=template&id=03f178c0&"
import script from "./CreateCoachResumeAccolades.vue?vue&type=script&lang=js&"
export * from "./CreateCoachResumeAccolades.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports